import moment from "moment";
import React, { useEffect, useRef, useState } from "react";

interface ClockElapseTimerProps {
    startform: string;
}

const ClockElapseTimer: React.FC<ClockElapseTimerProps> = ({ startform }) => {    
    const [elapsedTime, setElapsedTime] = useState<Array<any>>([]);
    useEffect(() => {
        //console.log('ClockElapseTimer', startform, moment.utc(startform).local().format('YYYY-MM-DD HH:mm:ss'));
        const startTime = moment.utc(startform).local().valueOf();
        const timerId = setInterval(() => {
            if (moment.utc(startform).local().isSameOrBefore(moment())) {
                const currentTime = moment().valueOf();
                //console.log(currentTime - startTime);
                const duration = moment.duration(Math.floor((currentTime - startTime)/1000), `seconds`);
                const outputarr = []
                /*
                if (duration.hours()) {
                    outputarr.push(`${+duration.hours() < 10 ? `0` : ``}${duration.hours()}`);
                } else {
                    outputarr.push(`00`);
                }
                
            
                if (duration.minutes()) {
                    outputarr.push(`${+duration.minutes() < 10 ? `0` : ``}${duration.minutes()}`);
                } else {
                    outputarr.push(`00`);
                }
                if (duration.seconds()) {
                    outputarr.push(`${+duration.seconds() < 10 ? `0` : ``}${duration.seconds()}`);
                } else {
                    outputarr.push(`00`);
                }
                */
                //var output = outputarr.join(`:`);
                const x = duration.asSeconds();
                //console.log('x', x, duration);
                Math.floor(x/3600) === 0 ? outputarr.push(`00`) : outputarr.push(`${Math.floor(x/3600) < 10 ? `0` : ``}${Math.floor(x/3600)}`);
                Math.floor(x/60)%60 === 0 ? outputarr.push(`00`) : outputarr.push(`${Math.floor(x/60)%60 < 10 ? `0` : ``}${Math.floor(x/60)%60}`);
                x%60 === 0 ? outputarr.push(`00`) : outputarr.push(`${x%60 < 10 ? `0` : ``}${x%60}`);            
                //console.log('outputarr', outputarr);
                setElapsedTime(outputarr); 
            } else {
                setElapsedTime([`00`,`00`, `00`]); 
            }           
        }, 1000);
        return () => clearInterval(timerId);
    }, []);
    return (
        <div>
            <div className={ `flex items-center gap-2 justify-end` }>
                <div className={ `relative` }>
                    <span className={ `absolute` } style={{ top: -10, fontSize: 12, color: `#767676` }}>HH</span>
                    <div style={{ color: `#2b5a2e`, fontWeight: `bold`, fontSize: 26, width: 34 }}>{ elapsedTime[0] }</div>
                </div>
                <div style={{ color: `#2b5a2e`, fontWeight: `bold`, fontSize: 26, width: 8 }}>:</div>
                <div className={ `relative` }>
                    <span className={ `absolute` } style={{ top: -10, fontSize: 12, color: `#767676` }}>MM</span>
                    <div style={{ color: `#2b5a2e`, fontWeight: `bold`, fontSize: 26, width: 34 }}>{ elapsedTime[1] }</div>
                </div>
                <div style={{ color: `#2b5a2e`, fontWeight: `bold`, fontSize: 26, width: 8 }}>:</div>
                <div className={ `relative` }>
                    <span className={ `absolute` } style={{ top: -10, fontSize: 12, color: `#767676` }}>SS</span>
                    <div style={{ color: `#2b5a2e`, fontWeight: `bold`, fontSize: 26, width: 34 }}>{ elapsedTime[2] }</div>
                </div>
            </div>
        </div>
    )
};

export default ClockElapseTimer;